export default __webpack_public_path__ + "images/SQS.0f79103.png";